import { ReactElement } from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { PrimaryButton } from '@/components';
import RefreshIcon from '@mui/icons-material/Refresh';

type ExperiencesListErrorProps = {
  refetch: VoidFunction;
};

export const ExperiencesListError = (
  props: ExperiencesListErrorProps,
): ReactElement => {
  return (
    <Box
      sx={{
        height: 'calc(100vh - 450px)',
        display: 'grid',
        placeItems: 'center',
      }}
    >
      <Stack alignItems="center" spacing={4}>
        <Typography fontSize={24} fontWeight={600}>
          Oops! Something went wrong.
        </Typography>

        <PrimaryButton onClick={props.refetch} startIcon={<RefreshIcon />}>
          Retry
        </PrimaryButton>
      </Stack>
    </Box>
  );
};
